<template>
    <div>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="pagination" :loading="tLoading"
            rowKey="logstorename">
            <!-- <template slot="tongbitext" slot-scope="text, record">
            <span v-if="record.iconflag == 'none'">{{text}}</span>
            <span v-else-if="record.iconflag == 'rise'" style="color:red;">{{text}} <a-icon type="rise" /></span>
            <span v-else style="color:green;">{{text}} <a-icon type="fall" /></span>
        </template> -->
            <template slot="operation" slot-scope="text, record">
                <div>
                    <span v-if="record.errcount == 'unknown'">
                        <a-button type="link" @click="handleSysRefresh(record)">刷新</a-button>
                    </span>

                    <span v-if="record.errcount != 'unknown'">
                        <a-button type="link" @click="handleSysView(record)">查看</a-button>
                    </span>
                </div>
            </template>

        </a-table>


    </div>
</template>
<script>

let pagination={
    pageSize:5,
}
const columns = [
    {
        title: "系统名称",
        dataIndex: "logstorename",
        width:80,
        align:'center',
    },
    {
        title: "异常数",
        dataIndex: "errcount",
        width:100,
        align:'center',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.errcount - b.errcount,
    },
    {
        title: "增长率",
        dataIndex: "growper",
        width:100,
        align:'center',
        sorter: (a, b) => {
            let tempVA = a.growper.split('%')[0];
            let tempVB = b.growper.split('%')[0];
            let tempA = parseFloat(tempVA) ? tempVA : 0;
            let tempB = parseFloat(tempVB) ? tempVB : 0;
            return tempA - tempB
        },
    },
    {
        title: "环比数量",
        dataIndex: "huanbi",
        width:100,
        align:'center',
        sorter: (a, b) => {
            let tempA = parseFloat(a.huanbi) ? a.huanbi : 0;
            let tempB = parseFloat(b.huanbi) ? b.huanbi : 0;
            return tempA - tempB
        },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 100,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            pagination,
            data:[],
            tLoading:false,
            sTime:'',
            eTime:'',
            timeType:'',
            listFolows:[],
        };
    },
    methods: {
    
        handleSysView(record){
            this.$router.push({
                path: "/monitorerror/trend",
                query:{
                    sysname:record.logstorename,
                    searchTimeRange:this.sTime + '~' + this.eTime,
                    dateTypeTitle:this.timeType
                }
            });
        },
        getFolowData(tRange,listFolows,timeType){
            if(listFolows.length == 0){
                return;
            }
            let starttime = tRange.split('~')[0] + ':00';
            let endtime = tRange.split('~')[1] + ':00';
            this.listFolows = listFolows;
            this.sTime = starttime;
            this.eTime = endtime;
            this.timeType = timeType;
            //先查缓存数据
            let tempData = this.getCacheData();
            if(tempData){
                this.data = tempData
            }
            else{
                //递归所有系统查询数据
                this.data = [];
                this.getSingleSysError(listFolows[0],false)
            }
        },
        handleSysRefresh(record){
            this.getSingleSysError(record.logstorename,true)
        },
        
        getSingleSysError(sysname,isSingle){
            let timerange = ( (new Date(this.eTime)).getTime() - (new Date(this.sTime)).getTime()) / 1000;
            let queryStartTime = (new Date(this.sTime).getTime())/1000;
            let queryEndTime = (new Date(this.eTime).getTime())/1000;


            let that = this;
            let queryStr = "* |SELECT " +
                "avg(diff[1]) AS errcount," +
                "avg(diff[2]) AS huanbi," +
                "concat(cast(avg(round((diff[3]-1.0)*100, 2)) AS varchar),'%') AS growper " +
                "from (" +
                "select compare(total , " + timerange + ") as diff from(" +
                "select COUNT(*) AS total FROM log " +
                "where message like '%Exception:%'" +
                ") " +
                ")";
    
            that.tLoading = true;
            let params = {
                projectname:that.projectname,
                logstorename:sysname,
                starttime:queryStartTime,
                endtime:queryEndTime,
                sql:queryStr,
                pageSize:10,
                offset:0,
                reverse:false,
                paged:false,
                timeout:5000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                let list = [];
                if(res.status == 200 && res.data.success == '1'){
                    list = res.data.data.list;
                }
                that.getSysErrorResult(isSingle,sysname,list);
                that.checkNext(isSingle,sysname);
            }).catch(() => {
                that.getSysErrorResult(isSingle,sysname,[]);
                that.checkNext(isSingle,sysname);
            });
        },
        getSysErrorResult(isSingle,sysname,list){
            let result = {}
            if(!isSingle){
                if(list.length > 0){
                    result = {
                        ...list[0],
                        logstorename:sysname
                    }
                }
                else{
                    result = {
                        logstorename:sysname,
                        errcount:'unknown',
                        growper:'unknown',
                        huanbi:'unknown'
                    }
                }
                this.data.push(result);
            }
            else{
                //单独刷新数据
                if(list.length > 0){
                    this.data.forEach(element => {
                        if(element.logstorename == sysname){
                            Object.assign(element,{
                                ...(list[0])
                            })
                            return false;
                        }
                    });
                }
            }
        },
        checkNext(isSingle,sysname){
            if(!isSingle){
                //判断是否有下一个系统
                let cIndex = this.listFolows.indexOf(sysname);
                let maxIndex = this.listFolows.length - 1;
                if(cIndex < maxIndex){
                    this.getSingleSysError(this.listFolows[cIndex + 1])
                }
                else{
                    this.tLoading = false;
                    this.updateCache();
                }
            }
            else{
                this.tLoading = false;
                this.updateCache();
            }
        },
        updateCache(){
            let currentID = this.getCacheID();
            let cachedData = {
                cId:currentID,
                cData: this.data
            }
            localStorage.setItem('overviewCachedSysErrors',JSON.stringify(cachedData));
        },
        getCacheID(){
            return JSON.stringify(this.listFolows) + this.sTime + this.eTime + this.timeType;
        },
        getCacheData(){
            let currentID = this.getCacheID();
            let currentCache = localStorage.getItem('overviewCachedSysErrors');
            if(currentCache){
                currentCache = JSON.parse(currentCache);
                if(currentCache.cId == currentID){
                    return currentCache.cData;
                }
                else {
                    return false;
                }
            }
            else{
                return false;
            }
        }
    },
    props:{
        folowsData:{
            listfolows:[]
        }
    },
    components:{
    },
    mounted(){
        let hostname = window.location.host;
        let projectname = ''
        if(hostname.split('.')[0] != 'fpvip'){
            projectname = 'app-logs-zl'
        }
        else{
            projectname = 'vip-app-logs-zl'
        }
        this.projectname = projectname
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
